import type { SVGProps } from 'react';

const SolarTableLinear = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
            <rect x="3" y="3" width="18" height="18" rx="3" />
            <path d="M3 8h18M3 14h18M9 8v13M15 8v13" />
        </g>
    </svg>
);

export default SolarTableLinear;
